import {httpGet,httpPut,httpDelete,httpPost} from '../../../util/request.js';
import appConfig from '../../../config';

export default class ModuleFunctionApi{

	static QUERY_MODULE_FUNC_API_URL = appConfig.gatewayUrl+appConfig.smpServicePath+"/sys/moduleFunctions/byModuleId";
	
	static QUERY_MENU_RELATE_FUNC_API_URL = appConfig.gatewayUrl+appConfig.smpServicePath+"/sys/moduleFunctions/byRelateMenuId";

	static QUERY_MENU_UI_FUNC_API_URL = appConfig.gatewayUrl+appConfig.smpServicePath+"/sys/moduleFunctions/byUiMenuId";
	
	static PERSIST_MODULE_FUNC_API_URL = appConfig.gatewayUrl+appConfig.smpServicePath+"/sys/moduleFunction";
	
	static queryByModuleId(moduleId){
		let params={"moduleId":moduleId};
		return httpGet(ModuleFunctionApi.QUERY_MODULE_FUNC_API_URL,params);
	}
	
	static persistModuleFunction(params){
		return httpPost(ModuleFunctionApi.PERSIST_MODULE_FUNC_API_URL,params);
	}
	
	static queryMenuRelateFunction(menuId){
		let params={"menuId":menuId};
		return httpGet(ModuleFunctionApi.QUERY_MENU_RELATE_FUNC_API_URL,params);
	}

	static queryMenuUiFunction(menuId){
		let params={"menuId":menuId};
		return httpGet(ModuleFunctionApi.QUERY_MENU_UI_FUNC_API_URL,params);
	}
	
}